var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.922,
    height: 19.78,
    viewBox: "0 0 23.922 19.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pause",
    "data-name": "Icon awesome-pause",
    d: "M7.689,21.959H2.563A2.374,2.374,0,0,1,0,19.84V4.3A2.374,2.374,0,0,1,2.563,2.18H7.689A2.374,2.374,0,0,1,10.252,4.3V19.84A2.374,2.374,0,0,1,7.689,21.959ZM23.922,19.84V4.3A2.374,2.374,0,0,0,21.359,2.18H16.233A2.374,2.374,0,0,0,13.67,4.3V19.84a2.374,2.374,0,0,0,2.563,2.119h5.126A2.374,2.374,0,0,0,23.922,19.84Z",
    transform: "translate(0 -2.18)",
    fill: "#1e1e1e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.7b3d302c646542d21bfeb12045edd5d5.svg";
export { ForwardRef as ReactComponent };